import { useTranslation } from "react-i18next";
import { WebsiteField } from "@shared/ui";

interface EventSourceUrlFieldProps {
  sourceUrl?: string | null;
  onDataChange: (sourceUrl: string) => void;
  error?: string;
  disabled?: boolean;
  helpText?: string;
  placeholder?: string;
}

export default function EventSourceUrlField({
  sourceUrl,
  onDataChange,
  error,
  disabled = false,
  helpText,
  placeholder,
}: EventSourceUrlFieldProps) {
  console.debug("[EventSourceUrlField::EventSourceUrlField]");

  const { t } = useTranslation();

  return (
    <WebsiteField
      label={t("eventDetails.overview.sourceUrl")}
      value={sourceUrl || ""}
      onChange={onDataChange}
      helpText={helpText ?? t("eventDetails.overview.sourceUrlHelp")}
      placeholder={placeholder ?? t("eventDetails.overview.sourceUrlPlaceholder")}
      error={error}
      disabled={disabled}
      requireHttps
    />
  );
}
